import { BOARD_CONFIG } from "@/config/browserBoard";

/** 板スコープAPIのpathへ現在板slugを末尾付与する。pathはクエリ無しの/始まりで渡す。 */
export function boardApiPath(path: string): string {
  return `${path}/${encodeURIComponent(BOARD_CONFIG.boardKey)}`;
}

/** 現在板のスレッド概要一括取得pathを返す。 */
export function boardSummaryApiPath(): string {
  return `/boards/${encodeURIComponent(BOARD_CONFIG.boardKey)}/summary`;
}
